/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-i18n-at-module-eval */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import text from 'I18n/utils/unescapedText';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { createPath } from 'DesignData/helpers/routingHelper';
import FileModel from 'DesignData/models/finder/File';
import { getFile as getFinderFile } from 'DesignData/selectors/finder';
import { getWidget } from 'DesignData/selectors/layoutData';
import { getFileDataFromResult, getFileTypeI18nKey } from 'DesignData/helpers/finderHelpers';
import { DIFFERENT_FILE_EXTENSION, INVALID_CUSTOM_HEAD, TEMPLATE_VALIDATION_FAILED } from 'DesignData/enums/ErrorTypes';
import { INVALID_SERVERLESS_FILE, FILENAME_CONTAINS_INVALID_CHAR } from 'DesignData/enums/FileUploadErrorTypes';
import UILink from 'UIComponents/link/UILink';
import { openDrawer } from 'DesignData/actions/EditorErrors';
import { FINDER_FILE_CREATE, FINDER_FILE_RESTORE_DELETED, FINDER_FOLDER_DUPLICATE, FINDER_FILE_DUPLICATE_READ_ONLY, FINDER_FILE_DUPLICATE, FINDER_FILE_RENAME, FINDER_FILE_COPY_PATH, FINDER_FILE_COPY_PUBLIC_URL, FINDER_FILE_COPY_MODULE_SNIPPET, LAYOUT_WIDGET_MAKE_CMV2_GLOBAL, FINDER_FOLDER_COPY_PATH, FINDER_FOLDER_CREATE, FINDER_FOLDER_RENAME, FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE, FINDER_FILE_UPLOAD, FINDER_PROJECTS_CREATE_RECEIVE, FINDER_PROJECTS_CREATE_ERROR, FINDER_PROJECTS_DEPLOY_RECEIVE, FINDER_PROJECTS_DEPLOY_ERROR, FINDER_FUNCTIONS_DEPLOY_ERROR, LAYOUT_CELL_MAKE_GLOBAL, FINDER_FOLDER_CONTENTS_MOVE, LAYOUT_WIDGET_RESTORE_PARENT, LAYOUT_PUBLISH, LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_GROUP, CUSTOM_WIDGET_BUFFER_PUBLISH, CUSTOM_WIDGET_SAVE_BY_PATH, GLOBAL_WIDGET_PUBLISH, TEMPLATE_BUFFER_PUBLISH, TEMPLATE_SAVE_BY_PATH, HUBL_DOCS_FETCH, CUSTOM_WIDGET_BUFFER_UPGRADE, CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE, CUSTOM_WIDGETS_MAPPING_FETCH, CUSTOM_WIDGETS_WITH_META_DATA_FETCH, RAW_ASSET_BUFFER_REPLACE, RAW_ASSET_PUBLISH, RAW_ASSET_SAVE_BY_PATH, LANGUAGES_FETCH } from 'DesignData/actions/ActionTypes';
import { i18nKey as notificationsI18nKey, showAppNotification } from 'DesignData/actions/AppNotifications';
import { CONFLICT, BAD_REQUEST } from 'DesignData/enums/HttpStatusCodes';
import { CUSTOM_WIDGET } from 'DesignData/constants/FolderAssetTypes';
import { isBadRequestError } from 'DesignData/helpers/errorHelper';
const {
  SafeString
} = I18n;

function i18nKey(actionType, notificationType, key) {
  return notificationsI18nKey(`${actionType}.${notificationType}.${key}`);
}

let moduleDuplicateName = null;

function checkForModuleDuplicateNameError(action, duplicateName) {
  if (duplicateName) {
    moduleDuplicateName = duplicateName;
  }

  const errorData = action.error && action.error.data && JSON.parse(action.error.data) || {};

  if (action.error && errorData.errorType === 'MODULE_VALIDATION_DUP_LABEL') {
    const message = moduleDuplicateName ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: notificationsI18nKey('duplicateModuleName.name'),
      options: {
        moduleDuplicateName
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: notificationsI18nKey('duplicateModuleName.generic')
    });
    return {
      notificationKey: action.type,
      type: 'danger',
      message
    };
  }

  return null;
}
/**
 * Export
 */


export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const {
    type: actionType
  } = result;

  switch (actionType) {
    case FINDER_FILE_RESTORE_DELETED:
      {
        const {
          file,
          fileType,
          error
        } = result;

        if (file) {
          const {
            name: fileName
          } = getFileDataFromResult(fileType, file);
          const fileAssetType = FileModel.getDesignAssetType(fileType);
          const fileRoute = createPath(fileAssetType, file.id);
          const notificationType = 'success';
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: notificationType,
            message: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: i18nKey(actionType, notificationType, 'message.text'),
              options: {
                fileName,
                fileLink: /*#__PURE__*/_jsx(UIRouterLink, {
                  to: fileRoute,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: i18nKey(actionType, notificationType, 'message.link.text')
                  })
                })
              }
            })
          }));
        } else if (error) {
          const {
            fileName
          } = result;
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            messageProps: {
              fileName
            }
          }));
        }

        break;
      }

    case FINDER_FOLDER_DUPLICATE:
      {
        const {
          error
        } = result;

        if (error) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            messageProps: {
              folderName: result.folderName
            }
          }));
        }

        break;
      }

    case FINDER_FOLDER_CREATE:
      {
        const {
          error,
          name
        } = result;

        if (error) {
          const {
            responseJSON
          } = error;

          if (error.status === 409 && responseJSON.message.indexOf('already exists') !== -1) {
            dispatch(showAppNotification({
              notificationKey: 'duplicateFolderName',
              type: 'danger',
              messageProps: {
                folderName: name
              }
            }));
          } else {
            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              messageProps: {
                folderName: name
              }
            }));
          }
        }

        break;
      }

    case FINDER_FOLDER_RENAME:
      {
        const {
          error,
          folderName,
          oldFolderName
        } = result;

        if (error) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            messageProps: {
              folderName: oldFolderName,
              newFolderName: folderName
            }
          }));
        }

        break;
      }

    case FINDER_FOLDER_COPY_PATH:
    case FINDER_FILE_COPY_PATH:
    case FINDER_FILE_COPY_PUBLIC_URL:
    case FINDER_FILE_COPY_MODULE_SNIPPET:
      {
        const {
          copied
        } = result;
        dispatch(showAppNotification({
          notificationKey: actionType,
          type: copied ? 'success' : 'danger'
        }));
        break;
      }

    case FINDER_FILE_CREATE:
      {
        const {
          error,
          fileName,
          fileType
        } = result;
        const duplicateNameError = checkForModuleDuplicateNameError(result, fileName);

        if (fileType === CUSTOM_WIDGET && duplicateNameError) {
          dispatch(showAppNotification(duplicateNameError));
          break;
        }

        if (error) {
          const notificationType = 'danger';
          const payload = {
            notificationKey: actionType,
            type: notificationType
          };

          if (error.status === CONFLICT) {
            const type = SafeString(text(getFileTypeI18nKey(fileType)).one);
            payload.message = /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, notificationType, 'conflictMessage'),
              options: {
                fileType: type,
                fileName
              }
            });
          } else {
            payload.messageProps = {
              fileName
            };
          }

          dispatch(showAppNotification(payload));
        }

        break;
      }

    case FINDER_FILE_UPLOAD:
      {
        const {
          error,
          file
        } = result;
        const fileName = file.name;

        if (error) {
          const notificationType = 'danger';
          const payload = {
            notificationKey: actionType,
            type: notificationType
          };

          const createMessage = errorKey => /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(actionType, notificationType, errorKey),
            options: {
              fileName
            }
          });

          if (error.status === CONFLICT) {
            payload.message = createMessage('conflictMessage');
          } else if (error.responseJSON && error.responseJSON.errorType === INVALID_SERVERLESS_FILE) {
            payload.message = createMessage('serverlessMessage');
          } else if (error.errorType === FILENAME_CONTAINS_INVALID_CHAR || error.responseJSON.errors && error.responseJSON.errors[0] && error.responseJSON.errors[0].errorType === FILENAME_CONTAINS_INVALID_CHAR) {
            payload.message = createMessage('invalidCharMessage');
          } else {
            payload.messageProps = {
              fileName
            };
          }

          dispatch(showAppNotification(payload));
        }

        break;
      }

    case FINDER_FILE_RENAME:
      {
        const {
          error,
          fileName,
          oldFileName
        } = result;
        const duplicateNameError = checkForModuleDuplicateNameError(result, fileName);

        if (duplicateNameError) {
          dispatch(showAppNotification(duplicateNameError));
        } else if (error) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            messageProps: {
              fileName: oldFileName,
              newFileName: fileName
            }
          }));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE_READ_ONLY:
      {
        const duplicateNameError = checkForModuleDuplicateNameError(result, result.duplicateName);

        if (duplicateNameError) {
          dispatch(showAppNotification(duplicateNameError));
        } else if (result.error && result.error.status === CONFLICT) {
          const regex = /\/(?!.*\/).+'/g;
          const regexResult = regex.exec(result.error.responseJSON.message);
          const assetName = regexResult ? regexResult[0].substr(1).slice(0, -1).trim() : moduleDuplicateName;
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', 'conflictMessage'),
              options: {
                assetName
              }
            })
          }));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE:
      {
        const {
          error,
          fileId
        } = action;
        const file = getFinderFile(getState(), {
          fileId
        });

        if (error) {
          const errorType = error.responseJSON && error.responseJSON.errorType;
          let messageKey = 'message';

          if (errorType === INVALID_CUSTOM_HEAD || errorType === TEMPLATE_VALIDATION_FAILED) {
            messageKey = 'validationError';
          }

          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', messageKey),
              options: {
                fileName: file.name
              }
            })
          }));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE:
      {
        const {
          error,
          fileId
        } = action;

        if (error) {
          const file = getFinderFile(getState(), {
            fileId
          });
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            messageProps: {
              fileName: file.name
            }
          }));
        }

        break;
      }

    case FINDER_FUNCTIONS_DEPLOY_ERROR:
      {
        const {
          error,
          folderPath
        } = action;
        const {
          errorReason = 'default'
        } = error;
        dispatch(showAppNotification({
          notificationKey: actionType,
          type: 'danger',
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(actionType, 'danger', `message.${errorReason}`),
            options: {
              folderPath
            }
          })
        }));
        break;
      }

    case FINDER_PROJECTS_CREATE_RECEIVE:
      {
        const {
          folderName
        } = action;
        dispatch(showAppNotification({
          notificationKey: actionType,
          type: 'success',
          message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: i18nKey(actionType, 'success', 'message_jsx'),
            options: {
              folderName,
              // TODO -- Update with public doc link
              learnMoreLink: 'https://www.google.com'
            },
            elements: {
              Link: UILink
            }
          })
        }));
        break;
      }

    case FINDER_PROJECTS_DEPLOY_RECEIVE:
      {
        const {
          folderPath
        } = action;
        dispatch(showAppNotification({
          notificationKey: actionType,
          type: 'success',
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(actionType, 'success', 'message'),
            options: {
              folderPath
            }
          })
        }));
        break;
      }

    case FINDER_PROJECTS_CREATE_ERROR:
      {
        const {
          folderName,
          error
        } = action;
        const {
          responseJSON: {
            errorType = 'default'
          }
        } = error;
        dispatch(showAppNotification({
          notificationKey: actionType,
          type: 'danger',
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(actionType, 'danger', `message.${errorType}`),
            options: {
              folderName
            }
          })
        }));
        break;
      }

    case FINDER_PROJECTS_DEPLOY_ERROR:
      {
        // TODO - Update BE failureReason to be an enum that we use to display
        // the corresponding translated error on the FE, then use commented code
        const {
          error
          /* folderPath */

        } = action; // const { failureReason = 'default' } = error;

        dispatch(showAppNotification({
          notificationKey: actionType,
          type: 'danger',
          message: error.failureReason // message: (
          //   <FormattedMessage
          //     message={i18nKey(
          //       actionType,
          //       'danger',
          //       `message.${failureReason}`
          //     )}
          //     options={{
          //       folderPath,
          //     }}
          //   />
          // ),

        }));
        break;
      }

    case LAYOUT_WIDGET_MAKE_CMV2_GLOBAL:
      {
        const widgetName = result.data && result.data.name;
        const duplicateNameError = checkForModuleDuplicateNameError(result, widgetName);

        if (duplicateNameError) {
          dispatch(showAppNotification(duplicateNameError));
        } else if (result.error) {
          dispatch(showAppNotification({
            notificationKey: 'convertToGlobalFailed',
            type: 'danger',
            messageProps: {
              moduleName: widgetName
            }
          }));
        }

        break;
      }

    case LAYOUT_CELL_MAKE_GLOBAL:
      {
        if (result.error) {
          if (result.error.status === CONFLICT) {
            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey(actionType, 'danger', 'conflictMessage'),
                options: {
                  groupName: result.groupName
                }
              })
            }));
            break;
          }

          const {
            layoutId,
            widgetId
          } = result;
          const currentWidget = getWidget(getState(), {
            layoutId,
            widgetId
          });
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', 'message'),
              options: {
                widgetLabel: currentWidget.label
              }
            })
          }));
        }

        break;
      }

    case FINDER_FOLDER_CONTENTS_MOVE:
      {
        if (result.error) {
          let key = 'message';
          let assetName = '';

          if (result.error.status === CONFLICT) {
            key = 'conflictMessage';
            const regex = /\/(?!.*\/).+'/g;
            const regexResult = regex.exec(result.error.responseJSON.message);
            assetName = regexResult ? regexResult[0].substr(1).slice(0, -1).trim() : assetName;
          }

          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: i18nKey(actionType, 'danger', key),
              options: {
                assetName
              }
            })
          }));
        }

        break;
      }

    case LAYOUT_WIDGET_RESTORE_PARENT:
    case LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_GROUP:
      {
        if (result.error) {
          const messageKey = result.error instanceof ReferenceError ? result.error.name : 'default';
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', `message.${messageKey}`),
              options: result.meta
            })
          }));
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_PUBLISH:
    case GLOBAL_WIDGET_PUBLISH:
    case LAYOUT_PUBLISH:
    case RAW_ASSET_PUBLISH:
    case TEMPLATE_BUFFER_PUBLISH:
      {
        const {
          customWidget,
          error,
          globalWidget,
          layout,
          publishedTemplate,
          rawAsset,
          template
        } = result;

        if (customWidget || globalWidget || layout || publishedTemplate || rawAsset || template) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'success',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'success', 'message')
            })
          }));
        } else if (error) {
          const {
            status
          } = error;

          if (status === BAD_REQUEST) {
            const consoleErrorsLink = /*#__PURE__*/_jsx(UILink, {
              onClick: () => dispatch(openDrawer()),
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: i18nKey(actionType, 'danger', 'link')
              })
            });

            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: i18nKey(actionType, 'danger', 'message'),
                options: {
                  consoleErrorsLink
                }
              })
            }));
          } else {
            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey(actionType, 'danger', 'defaultMessage')
              })
            }));
          }
        }

        break;
      }

    case RAW_ASSET_SAVE_BY_PATH:
    case TEMPLATE_SAVE_BY_PATH:
    case CUSTOM_WIDGET_SAVE_BY_PATH:
      {
        const {
          error,
          rawAsset,
          template,
          customWidget
        } = result;
        const asset = rawAsset || template || customWidget;

        if (asset) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'success',
            message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: i18nKey(actionType, 'success', 'message_jsx'),
              options: {
                asset,
                // TODO -- Update this when we have public docs
                learnMoreLink: 'https://www.google.com'
              },
              elements: {
                Link: UILink
              }
            })
          }));
        } else if (error) {
          const {
            status
          } = error;

          if (status === BAD_REQUEST) {
            const consoleErrorsLink = /*#__PURE__*/_jsx(UILink, {
              onClick: () => dispatch(openDrawer()),
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: i18nKey(actionType, 'danger', 'link')
              })
            });

            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: i18nKey(actionType, 'danger', 'message'),
                options: {
                  consoleErrorsLink
                }
              })
            }));
          } else {
            dispatch(showAppNotification({
              notificationKey: actionType,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey(actionType, 'danger', 'defaultMessage')
              })
            }));
          }
        }

        break;
      }

    case CUSTOM_WIDGETS_WITH_META_DATA_FETCH:
    case CUSTOM_WIDGETS_MAPPING_FETCH:
    case HUBL_DOCS_FETCH:
      {
        if (result.error) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', 'message')
            })
          }));
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_UPGRADE:
    case CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE:
      {
        const {
          error
        } = result;

        if (error && !isBadRequestError(error)) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', 'message')
            })
          }));
        }

        break;
      }

    case RAW_ASSET_BUFFER_REPLACE:
      {
        const {
          error
        } = result;

        if (error) {
          let notification = {
            notificationKey: actionType,
            type: 'danger',
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(actionType, 'danger', 'message')
            })
          };

          if (error === DIFFERENT_FILE_EXTENSION) {
            const actionTypeKey = `${actionType}.${DIFFERENT_FILE_EXTENSION}`;
            notification = {
              notificationKey: actionTypeKey,
              type: 'danger',
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey(actionTypeKey, 'danger', 'message')
              })
            };
          }

          dispatch(showAppNotification(notification));
        }

        break;
      }

    case LANGUAGES_FETCH:
      {
        const {
          error
        } = result;

        if (error) {
          dispatch(showAppNotification({
            notificationKey: actionType,
            type: 'danger'
          }));
        }

        break;
      }

    default:
      break;
  }

  return result;
});